import React, { Fragment, useEffect, useState, useContext } from 'react'
import { Link, withRouter } from 'react-router-dom'
import styled, { css } from 'styled-components';
import { Context } from '../context';
import { getMetadataCategories, getDataById } from './utils';
import { ContentInfoLine } from './ContentInfo';
import uniqid from "uniqid";
import { UIinput } from '../uikit/UIinput';
import { UIemojiSelect } from '../uikit/UIemojiSelect';
import { UIbutton } from '../uikit/Uikit';
import './gs_add.css';


export function MetadataThreadsList({ videoId }) {
  const context = useContext(Context);

  const [query, setQuery] = useState('');


  return (
    <>



      <div className="l_pop_width">
        <div className="l_pop_content">
        {Boolean(getMetadataCategories(context, videoId, true, false, true).length) &&
          getMetadataCategories(context, videoId, true, false, true)
            .map((typeRef) => {
              // debugger
              return (<>
                {typeRef && <div
                  key={`metadata_${uniqid()}`}
                  className="l_pop_line l_pop_line--sm">
                  <ContentInfoLine
                  videoId={videoId}
                  view={'edit'}

                  typeRef={typeRef}
                  handleClick={() => void (0)}
                  />
                </div>}
              </>
              );
            })}

        </div>


      </div>


      <div className="x_threads_existing">

        <div className="l_pop_width">
          <div className="l_pop_content">

            <div className="l_pop_line">
              <div className="x_threads_add_form">

                <UIinput label='Find or create a thread' width="100%"
                  icon={<div className='ico'>search</div>}
                  style={{
                    border: '2px solid var(--main-accent-color)',
                    borderRadius: '0.6em'
                  }}
                  // extra={'x'}
                  value={query}
                  handle={(q) => {
                    setQuery(q)
                  }}
                >
                </UIinput>


                <div />

              </div>
            </div>


        {Boolean(getMetadataCategories(context, videoId, false, true).length) &&
          getMetadataCategories(context, videoId, false, true)
              .filter(typeRef => {
                const threadInfo = getDataById(context, 'metaDataTypes', typeRef);
                return query.length ? threadInfo['title'].toLowerCase().indexOf(query.toLowerCase()) > -1 : true;
              })
            .map((typeRef) => {
              // debugger
              return (<>
                {typeRef && <ContentInfoLine
                  videoId={videoId}
                  view={'add'}
                  key={`metadata_${uniqid()}`}
                  typeRef={typeRef}
                  handleClick={() => void (0)}
                />}
              </>
              );
            })}





          </div>
        </div>

      </div>

      {query.length > 3 && <div className="x_threads_add0">

        <div className="l_pop_width">
          <div className="l_pop_content">

            {/* <div className="l_pop_line">
              Create a new thread
            </div> */}

            <div className="l_pop_line">

              <div className="x_threads_add_form">
                <span className=''>
                  <UIemojiSelect
                  />
                </span>

                <div className='x_threads_add_title'>
                  {query}
                </div>

                <div className="x_threads_add_confirm">
                  <UIbutton sm
                    onClick={() => setQuery('')}
                  >
                    Create thread
                  </UIbutton>
                </div>


              </div>
            </div>

          </div>
        </div>

      </div>}



    </>
  )
}